// extracted by mini-css-extract-plugin
module.exports = {"root":"SalesGoals_root__N_C4U"};